import { useState } from "react";

import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx"; 
import { useMediaQuery } from "react-responsive";
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"

import InfoSVG from '../../assets/InfoSVG.jsx'; 
import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import InfoModal from "../InfoModal.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";

const Possession = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, formId, handlePcoaChange, handlePossessionPerDiemChange } = useFormContext(); 
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); 
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const { user } = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const handleInfoClick = () => {
        setIsInfoModalOpen(true); 
    }; 

    const handleCloseInfoModal = () => {
        setIsInfoModalOpen(false); 
    }

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const InfoModalContent =
        {
        title: "What is a PCOA? Do I Need It?",
        content: "A post-closing occupancy agreement is an arrangement between the buyer and seller of a property where the seller lives in the home as a tenant while they are renting and buying time to find a replacement property, coordinate their move, etc. In Colorado, a typical post-closing occupancy period is up to 60 days after closing. During the post-closing occupancy period, the seller will typically pay to cover the cost of utilities and other expenses associated with the property. Water is usually transferred into the buyers name after closing, so the seller usually pays for gas and electricity. The seller may also be required to provide a security deposit to the buyer to ensure that the property is returned in the same condition as it was when the buyer did their final walk through before closing.",
        secondHeader: "Can Shishito Help With This?",
        secondContent: "Yes Shishito can help you craft one of these as well. The process is very straight forward a common occurrence in real estate transactions."

        }; 

    const currentPageValue = 2;
    const currentSubStepProgress = 6/7; 
    

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750} gap={0}>

        <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
            <div className="w-full inline-flex justify-between md:pr-6 items-center mb-8">
                <div className="flex flex-row gap-2 items-center">
                    <InfoSVG onClick={handleInfoClick} height={20}/>
                    {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Possession</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Possession</h3>}    
                </div>
                
                <div className='items-center h-auto gap-2 md:gap-4 inline-flex'>
                    <HelpButton onClick={toggleAssist}/>
                    <SaveButton formData={formData} formId={formId}/>
                    {user && <PDFPreview formData={formData}/>}
                </div>
            </div>    
            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Agree to Execute a Post Closing Occupancy Agreement (PCOA)</span>
                    <span className="w-full h-auto text-shi-purple text-[13px] md:text-xs font-['Inter'] mb-5">This is a contract between a buyer and seller that lays out specifics for a seller staying in the property beyond the closing date.</span>
                    <span className="w-full h-auto text-red-700 text-[13px] md:text-xs font-['Inter'] mb-5">If you select "YES", you will need to fill out and send a PCOA document, which you can find under Shishito "Forms". Shishito has not added this form as a fillable product so you will have to do so manually.</span>
                </div>
                
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center w-full">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="pcoaYes" 
                            value="pcoaYes" 
                            checked={formData.isPcoa === 'pcoaYes'} 
                            onChange={(e) => handlePcoaChange('isPcoa', e.target.value)}
                            
                        />
                        <div className="flex flex-col justify-between">
                            <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                        </div>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="pcoaNo"
                            value="pcoaNo" 
                            checked={formData.isPcoa === 'pcoaNo'} 
                            onChange={(e) => handlePcoaChange('isPcoa', e.target.value)}
                        />
                    <div className="flex flex-col justify-between">
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                    </div>
                </div>
            </div>

            {/* PRIMARY RESIDENCE */}
            <div className="flex flex-col mt-8">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Will This Be Your Primary Residence?</span>
                    {/* <span className="w-[650px] h-auto text-shi-purple text-xs font-['Inter'] mb-5"></span> */}
                </div>
                
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center w-full">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="primaryResidenceYes" 
                            value="yes" 
                            checked={formData.primaryResidence === 'yes'} 
                            onChange={(e) => handlePcoaChange('primaryResidence', e.target.value)}
                            
                        />
                        <div className="flex flex-col justify-between">
                            <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                        </div>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="primaryResidenceNo"
                            value="no" 
                            checked={formData.primaryResidence === 'no'} 
                            onChange={(e) => handlePcoaChange('primaryResidence', e.target.value)}
                        />
                    <div className="flex flex-col justify-between">
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                    </div>
                </div>
            </div>


            <div className="flex flex-col my-8">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Failure to Deliver Possession on Close</span>
                    <span className="w-full h-auto text-shi-purple text-[13px] md:text-xs font-['Inter'] mb-5">If the seller after Closing fails to deliver possession as specified this is the payment per day from the Seller to the Buyer. Typically $300/day</span>
                </div>                
                <div className="w-full py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex">
                    <div className=" text-black font-semibold font-['Inter']">$</div>
                        <input 
                            type="text"
                            name="possessionPerDiem"
                            className="text-left pl-2 w-full"
                            value={formData.possessionPerDiem}
                            onChange={handlePossessionPerDiemChange}
                        />
                </div>
            </div>
        </div>

            {/* BOTTOM BUTTONS */}
          
        <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
            <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                Back
            </button>
            <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                Next
            </button>
        </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}

        <InfoModal isOpen={isInfoModalOpen} onClose={handleCloseInfoModal}>
                <div>
                    <h1 className="text-shi-green text-2xl font-bold mb-4">{InfoModalContent.title}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.content}</p>

                    <h1 className="text-shi-green text-2xl font-bold my-4">{InfoModalContent.secondHeader}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.secondContent}</p>
                </div>
        </InfoModal>
        </div>
        
    )
}

export default Possession; 